import React, { useState, useRef } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  FormControlLabel,
  IconButton,
  MenuItem,
  RadioGroup,
  Radio,
  Snackbar,
  Toolbar,
  Tooltip,
  Typography,
} from "@material-ui/core";
import HelpIcon from '@material-ui/icons/Help';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles } from "@material-ui/core/styles";
import useInput from "../../hooks/input";
import { Auth } from 'aws-amplify';
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from 'react-router-dom';
import { host, enableBilling } from "../../../data";
import { billing } from "../../../services/billing";
import AddDevice from "./AddDevice";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
    marginBottom: 20
  },
  formControlDensity: {
    margin: theme.spacing(1),
    minWidth: 100,
    marginBottom: 20
  },
  formControlNumber: {
    margin: theme.spacing(1),
    minWidth: 240,
    marginBottom: 20
  },
  formControlDensitySelect: {
    margin: theme.spacing(1),
    minWidth: 300,
    marginBottom: 20
  },
  btnActions: {
  },
  clickButtons: {
    marginRight: theme.spacing(2),
  },
  deviceWarning: {
    margin: theme.spacing(0),
    minWidth: 400,
    marginBottom: 20
  },
  cols: {
    paddingRight: 15
  },
  grow: {
    flexGrow: 1,
  },
}));

const TLMSettings = ({ orgInfo, branchInfo, site, siteId, tankId, handleExit, tankName, tlm = {}, devices, pulseDevices, setTankData, updateDevices }) => {
  const classes = useStyles();
  let history = useHistory();
  const { t, i18n } = useTranslation();
  const measurementTimes = [{ label: "00:00", value: 0 }, { label: "01:00", value: 1 }, { label: "02:00", value: 2 },
  { label: "03:00", value: 3 }, { label: "04:00", value: 4 }, { label: "05:00", value: 5 }, { label: "06:00", value: 6 },
  { label: "07:00", value: 7 }, { label: "08:00", value: 8 }, { label: "09:00", value: 9 }, { label: "10:00", value: 10 },
  { label: "11:00", value: 11 }, { label: "12:00", value: 12 }, { label: "13:00", value: 13 }, { label: "14:00", value: 14 },
  { label: "15:00", value: 15 }, { label: "16:00", value: 16 }, { label: "17:00", value: 17 }, { label: "18:00", value: 18 },
  { label: "19:00", value: 19 }, { label: "20:00", value: 20 }, { label: "21:00", value: 21 }, { label: "22:00", value: 22 },
  { label: "23:00", value: 23 }];
  const measurementTimes2 = [{ label: t("none_caps"), value: t("none_caps") }, { label: "00:00", value: 0 }, { label: "01:00", value: 1 }, { label: "02:00", value: 2 },
  { label: "03:00", value: 3 }, { label: "04:00", value: 4 }, { label: "05:00", value: 5 }, { label: "06:00", value: 6 },
  { label: "07:00", value: 7 }, { label: "08:00", value: 8 }, { label: "09:00", value: 9 }, { label: "10:00", value: 10 },
  { label: "11:00", value: 11 }, { label: "12:00", value: 12 }, { label: "13:00", value: 13 }, { label: "14:00", value: 14 },
  { label: "15:00", value: 15 }, { label: "16:00", value: 16 }, { label: "17:00", value: 17 }, { label: "18:00", value: 18 },
  { label: "19:00", value: 19 }, { label: "20:00", value: 20 }, { label: "21:00", value: 21 }, { label: "22:00", value: 22 },
  { label: "23:00", value: 23 }];
  const marks = [{ value: 0, label: '0%' }, { value: 100, label: '100%' }];
  const tankTypes = ["Regular", "Waste"];
  const tlmSerialNumber = useInput(tlm.serial || '');
  const rtlmSerialNumber = useRef("");
  const [measurementTime, setMeasurementTime] = useState(tlm.MeasurementTime_1 || '7');
  const [secondMeasurementTime, setSecondMeasurementTime] = useState(tlm.MeasurementTime_2 || t("none_caps"));
  const [dimensionUnit, setDimensionUnit] = useState(tlm.DimensionUnit || 'inches');
  const [tankType, setTankType] = useState(tlm.TankType || "Regular");
  const [tlmMeasurementOffset, setTlmMeasurementOffset] = useState(tlm.Offset || '0');
  const rtlmMeasurementOffset = useRef("");
  const isFillLevelAlarm = useInput(tlm.isFillLevelAlarm || "false");
  const fillAlarmValue = useInput(tlm.FillAlarmValue);
  const rfillAlarmValue = useRef("");
  const [fluidDensity, setFluidDensity] = useState(tlm.Density || "");
  const rdensity = useRef("");
  //kg/m^3, nominal temperature
  const [offsetHelpOpen, setOffsetHelpOpen] = useState(false);
  const fluidDensityList = [{ name: t("sae5W30"), density: 859 },
  { name: t("sae5W20"), density: 850 },
  { name: t("sae10W30"), density: 875 },
  { name: t("sae10W40"), density: 872 },
  { name: t("sae0W20"), density: 848 },
  { name: t("diesel"), density: 850 },
  { name: t("gasoline"), density: 730 },
  { name: t("def"), density: 1084 },
  { name: t("atf"), density: 833 },
  { name: t("water"), density: 998 },
  { name: t("windshieldFluid"), density: 850 },
  { name: t("antifreeze"), density: 1113 },
  { name: t("kerosene"), density: 804 },
  { name: t("custom"), density: null },
  ];
  const [selectFluidDensity, setSelectFluidDensity] = useState(tlm.DensityFluidType || fluidDensityList[fluidDensityList.length - 1].name);
  const [selectedDevice, setSelectedDevice] = useState({ id: 0, uid: tlm.serial, type: tlm.type });
  const isLowLevelAlarm = useInput(tlm.isLowLevelAlarm || 'false');
  const lowLevelAlarmValue = useInput(tlm.LowLevelAlarmValue);
  const rlowLevelAlarmValue = useRef("");
  const isCriticallyLowLevelAlarm = useInput(tlm.isCriticallyLowLevelAlarm || 'false');
  const criticallyLowLevelAlarmValue = useInput(tlm.CriticallyLowLevelAlarmValue);
  const rcriticallyLowLevelAlarmValue = useRef("");
  const [notification, setNotification] = useState({
    open: false,
    message: ""
  });
  const gpsSettings = [{value: 0, label: t("disabled")}, {value: 1, label: t("everyMeasurement")}, {value: 2, label: t("weekly")}];
  const waveguideSettings = [{value: 0, label: t('no')}, {value: 1, label: t("yes")}];
  const [hasBillingInfo, setHasBillingInfo] = useState(false);

  const [gpsDialogueOpen, setGpsDialogueOpen] = useState(false);
  const [gpsEnableSelect, setGpsEnableSelect] = useState(tlm.gps_enable ? gpsSettings[tlm.gps_enable] : gpsSettings[0]);
  const [t_gpsEnableSelect, setTempGpsEnableSelect] = useState(gpsSettings[0]);

  const [waveguideEnableSelect, setWaveguideEnableSelect] = useState(tlm.waveguide_enable ? waveguideSettings[tlm.waveguide_enable] : waveguideSettings[0]);

  const [removeMonitorDialogue, setRemoveMonitorDialogue] = useState(false);

  const openRemoveTlm = () => {
    setRemoveMonitorDialogue(true);
  }
  const handleRemoveMonitorDialogueClose = () => {
    setRemoveMonitorDialogue(false);
  }
  
  const handleRemoveMonitor = () => {
    Auth.currentAuthenticatedUser()
            .then(data => {
                var body = JSON.stringify({ 'uid': selectedDevice.uid });
                var requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': data.signInUserSession.idToken.jwtToken
                    },
                    body: body
                };

                fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId + '/tlm/', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                        if (data.error === "OK") {
                          //data.deviceList; data.tankData
                          setNotification({ open: true, message: t("monitorRemoved")});
                          setTankData(data.tankData);
                          updateDevices(data);
                          setSelectedDevice({ id: 0, uid: "", type: "" });
                        }
                        else {
                            if (data.error === "error" && data.errorList.length > 0) {
                                alert(data.errorList[0].error);
                            } else {
                                alert(data.error);
                            }
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
                setRemoveMonitorDialogue(false);
            });
  }
  
  const handleWaveguideEnableList = (targetValue) => {
    setWaveguideEnableSelect(waveguideSettings[targetValue]);
  };
  console.log(tlm);
  const handleGpsEnableList = (targetValue) => {
    //console.log(targetValue);
    setTempGpsEnableSelect(gpsSettings[targetValue]);
    if (targetValue === 0) {
      setGpsEnableSelect(gpsSettings[targetValue]);
    }
    else {
      setGpsDialogueOpen(true);
    }
  };

  const handleGpsDialogueClose = () => {
    setGpsDialogueOpen(false);
    setTempGpsEnableSelect(gpsSettings[0]);
  }

  const handleSetGpsCheck = () => {
    setGpsEnableSelect(t_gpsEnableSelect);
    setGpsDialogueOpen(false);
  }

  React.useEffect(() => {
    if (selectedDevice.type !== 'pressure' && selectedDevice.type !== "cellular") {
      setGpsEnableSelect(gpsSettings[0]);
      setWaveguideEnableSelect(waveguideSettings[0]);
    }
  }, [selectedDevice])

  React.useEffect(() => {
    (async () => {
      try {
        const { status, data } = await billing.getBillingData(
          orgInfo.orgId
        );

        const { error, billing_account, org_billing } = data;

        if (status === 404) {
          console.log(status);
        }

        if (error !== 'OK' && status !== 200) {
          throw new Error(error);
        }
        if (billing_account.billing_info.id) {
          setHasBillingInfo(true);
        }
        else {
          setHasBillingInfo(false);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [orgInfo]);

  const handleNotificationClose = () => setNotification({ open: false, message: "" });

  function validateData() {
    var ret = 1;

    if (!selectedDevice.uid) {
      console.log("TLM Serial Number Invalid");
      alert(t("tlmSerialNumberInvalid"));
      ret = 0;
    }

    const regex = /^([a-zA-Z0-9]){0,32}$/i;
    if (!regex.test(selectedDevice.uid)) {
      alert(t("illegalTlmSerialNumber"))
      ret = 0;
    }

    if (isFillLevelAlarm.value === 'true') {
      if (!fillAlarmValue.value) {
        console.log("High Alarm Value Invalid");
        alert(t("highAlarmValue"));
        ret = 0;

      } else if (parseFloat(fillAlarmValue.value) < 1) {
        ret = 0;
        console.log("High Level Alarm must be greater than 0");
        alert(t("highLevelAlarm"));
      }

      if (tlm.TankShape === "pulseHUB" && (parseFloat(fillAlarmValue.value) > 100)) {
        console.log("Pulse HUB High level Alarm must not exceed 100%");
        alert(t("pulseHubHighLevel"));
      }
    }

    if (isLowLevelAlarm.value === 'true') {
      if (!lowLevelAlarmValue.value) {
        console.log("Low Level Alarm Value Invalid");
        alert(t("lowLevelAlarmInvalid"));
        ret = 0;

      } else if (parseFloat(lowLevelAlarmValue.value) < 1) {
        ret = 0;
        console.log("Low Level Alarm must be greater than 0");
        alert(t("lowLevelAlarmMustBeGreater"));
      }

      if (tlm.TankShape === "pulseHUB" && (parseFloat(lowLevelAlarmValue.value) > 100)) {
        console.log("Pulse HUB Low level Alarm must not exceed 100%");
        alert(t("pulseHubLowLevelAlarm"));
      }
    }
    if (isCriticallyLowLevelAlarm.value === 'true') {
      if (!criticallyLowLevelAlarmValue.value) {
        console.log("Critical Level Alarm Value Invalid");
        alert(t("criticalLevelAlarmInvalid"));
        ret = 0;

      } else if (parseFloat(criticallyLowLevelAlarmValue.value) < 1) {
        ret = 0;
        console.log("Critical Level Alarm must be greater than 0");
        alert(t("criticalLevelAlarmMustBeGreater"));
      }

      if (tlm.TankShape === "pulseHUB" && (parseFloat(criticallyLowLevelAlarmValue.value) > 100)) {
        console.log("Pulse HUB Critical level Alarm must not exceed 100%");
        alert(t("pulseHubCriticalLevelAlarm"));
      }
    }
    return ret;
  };

  const handleClick = async (bExit) => {
    try {
      let user = await Auth.currentAuthenticatedUser();
      user.getSession((err, session) => {
        if (err) {
          console.log(err);
          return;
        }

        const sessionToken = session.getIdToken().jwtToken;
        var clientTimeZoneOffset = new Date().getTimezoneOffset() / 60;
        var adjustedMeasurementTime1 = measurementTime;

        if (measurementTime !== t("none_caps")) {
          adjustedMeasurementTime1 = parseInt(measurementTime) + clientTimeZoneOffset;

          if (adjustedMeasurementTime1 < 0) {
            adjustedMeasurementTime1 = adjustedMeasurementTime1 + 24;
          }

          if (adjustedMeasurementTime1 > 23) {
            adjustedMeasurementTime1 = adjustedMeasurementTime1 - 24;
          }

          adjustedMeasurementTime1 = adjustedMeasurementTime1.toString()
        }

        var adjustedMeasurementTime2 = secondMeasurementTime;
        if (secondMeasurementTime !== t("none_caps")) {
          adjustedMeasurementTime2 = parseInt(secondMeasurementTime) + clientTimeZoneOffset;

          if (adjustedMeasurementTime2 < 0) {
            adjustedMeasurementTime2 = adjustedMeasurementTime2 + 24;
          }

          if (adjustedMeasurementTime2 > 23) {
            adjustedMeasurementTime2 = adjustedMeasurementTime2 - 24;
          }
          adjustedMeasurementTime2 = adjustedMeasurementTime2.toString();
        }

        var tlm_offset;

        if (!tlmMeasurementOffset) {
          tlm_offset = "0";
          setTlmMeasurementOffset(tlm_offset);
        } else {
          tlm_offset = tlmMeasurementOffset;
        }
        
        var l_gps_enable = gpsEnableSelect.value;
        //var l_gps_enable = 0;
        //if (gpsEnableCheck){
        //  l_gps_enable = 1;
        //}
        let l_waveguide_enable = waveguideEnableSelect.value;
        var body = JSON.stringify(
          {
            "tank_id": tankId,
            "serial": selectedDevice.uid,
            "Params": [
              {
                "MeasurementTime_1": adjustedMeasurementTime1,
                "MeasurementTime_2": adjustedMeasurementTime2,
                "Density": fluidDensity,
                "DensityFluidType": selectFluidDensity.name,
                "isFillLevelAlarm": isFillLevelAlarm.value,
                "TankType": tankType,
                "FillAlarmValue": fillAlarmValue.value,
                "isLowLevelAlarm": isLowLevelAlarm.value,
                "LowLevelAlarmValue": lowLevelAlarmValue.value,
                "isCriticallyLowLevelAlarm": isCriticallyLowLevelAlarm.value,
                "CriticallyLowLevelAlarmValue": criticallyLowLevelAlarmValue.value,
                "Offset": tlm_offset,
                "gps_enable": l_gps_enable,
                "waveguide_enable": l_waveguide_enable
              }
            ],
            "ParentId": siteId,
            'User': user.attributes.email
          }
        );

        var dataValid = validateData();
        if (dataValid) {
          var requestOptions = {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': sessionToken
            },
            body: body
          };

          fetch(host + '/orgs/' + orgInfo.orgId + '/branches/' + branchInfo.branchId + '/sites/' + siteId + '/tanks/' + tankId, requestOptions)
            .then(async response => response.json())
            .then(data => {
              if (data.error === "OK") {
                console.log("Tank updated");
                if (bExit) {
                  let url = { pathname: ('/orgs/').concat(orgInfo.orgName).concat('/branches/').concat(branchInfo.branchName).concat('/sites/').concat(site) };
                  history.push(url);
                } else {
                  setNotification({ open: true, message: t("tankUpdated")});
                  setTankData(data.tankData);
                }
              } else {
                alert(data.error);
                // console.log(data);
              }
            }).catch(error => console.error('Error:', error))
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleDensitySelect = (data_in) => {
    if (data_in.density !== null) {
      setFluidDensity(data_in.density);
    }
    setSelectFluidDensity(data_in.name);
  };

  const handleFluidDensityChange = (data_in) => {
    if (data_in >= 0 && data_in < 10000) {
      setFluidDensity(data_in);
      setSelectFluidDensity(fluidDensityList[fluidDensityList.length - 1].name);
    }
  };

  const handleOffsetHelpOpen = () => {
    setOffsetHelpOpen(true);
  };
  const handleOffsetHelpClose = () => {
    setOffsetHelpOpen(false);
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={notification.open}
        message={notification.message}
        autoHideDuration={5000}
        onClose={handleNotificationClose} />
      <Grid item xs>
        {!enableBilling && orgInfo.isOrgEditor === true && <Button
          component={RouterLink}
          to={"/orgs/" + orgInfo.orgName + "/billing"}
          size='large'
          color='inherit'>
          {t("addDevices_caps")}
        </Button>}
        {enableBilling && orgInfo.isOrgEditor === true && <AddDevice orgInfo={orgInfo}
          branchInfo={branchInfo}
          siteId={siteId}
          updateDevices={updateDevices}
          hasBillingInfo={hasBillingInfo} />}
        {orgInfo.isOrgEditor === false && <Typography>
          {t("contactOrganization")}
        </Typography>}
      </Grid>
      <Grid item xs>
        {false && <FormControl className={classes.formControl}>
          <TextField label={t("serialNumber")} {...tlmSerialNumber}
            inputRef={rtlmSerialNumber}
          />
        </FormControl>}
        {tlm.TankShape !== "pulseHUB" && <Grid item container xs>
        <FormControl className={classes.formControl}>
          {devices.length > 0 ? 
            <TextField select
              label={t("levelMonitor")}
              value={selectedDevice.uid}
              onChange={e => {
                for (var i = 0; i < devices.length; i++) {
                  if (e.target.value === devices[i].uid) {
                    setSelectedDevice(devices[i]);
                    break;
                  }
                }
              }}>
              {devices.map(device => <MenuItem key={device.id} value={device.uid}>
                {device.uid}
              </MenuItem>)}
            </TextField>
            : <TextField className={classes.deviceWarning} label={t("levelMonitor")} value={t("thisOrganizationhasNoUsedDevices")}> </TextField>}
          </FormControl>
          {selectedDevice.uid && <IconButton onClick={openRemoveTlm}>
              <ClearIcon/>
            </IconButton>}
        </Grid>}
        {tlm.TankShape === "pulseHUB" && <Grid item container xs>
        <FormControl className={classes.formControl} >
          {pulseDevices.length > 0 ? <TextField select
            label={t("pulseHubUid")}
            value={selectedDevice.uid}
            onChange={e => {
              for (var i = 0; i < pulseDevices.length; i++) {
                if (e.target.value === pulseDevices[i].uid) {
                  setSelectedDevice(pulseDevices[i]);
                  break;
                }
              }
            }}>
            {pulseDevices.map(device => <MenuItem key={device.id} value={device.uid}>
              {device.uid}
            </MenuItem>)}
          </TextField>
            : <TextField className={classes.deviceWarning} label={t("levelMonitor")} value={t("thisOrganizationhasNoUsedDevices")}> </TextField>}
        </FormControl>
        {selectedDevice.uid && <IconButton onClick={openRemoveTlm}>
              <ClearIcon/>
            </IconButton>}
        </Grid>}
      </Grid>

      {(selectedDevice.type === "pressure") && <Grid item xs> <Toolbar>
        <FormControl className={classes.formControlDensitySelect} >
          <TextField select
            label={t("fluidTypeForDensity")}
            value={selectFluidDensity}
            helperText={" "}
            onChange={e => {
              for (var i = 0; i < fluidDensityList.length; i++) {
                if (e.target.value === fluidDensityList[i].name) {
                  handleDensitySelect(fluidDensityList[i]);
                  break;
                }
              }
            }}>
            {fluidDensityList.map(density => <MenuItem key={density.name} value={density.name}>
              {density.name}
            </MenuItem>)}
          </TextField>
        </FormControl>
        <FormControl className={classes.formControlDensity}>
          <TextField label={t("fluidDensity")} type="number"
            value={fluidDensity}
            onChange={(e) => handleFluidDensityChange(e.target.value)}
            inputRef={rdensity}
            helperText={"kg/m³"}
          />
        </FormControl>
      </Toolbar>
      </Grid>}

      <Grid item xs>
        {tlm.TankShape !== "pulseHUB" && <FormControl className={classes.formControl} >
          <TextField
            select
            label={t("measurementTime")}
            value={measurementTime}
            onChange={e => setMeasurementTime(e.target.value)}
          >
            {measurementTimes.map(time => <MenuItem key={time.value} value={time.value}>
              {time.label}
            </MenuItem>)}
          </TextField>
        </FormControl>}
      </Grid>
      <Grid item xs>
        {true && tlm.TankShape !== "pulseHUB" && <FormControl className={classes.formControl} >
          <TextField
            select
            label={t("secondMeasurementTime")}
            value={secondMeasurementTime}
            onChange={e => setSecondMeasurementTime(e.target.value)}
          >
            {measurementTimes2.map(time => <MenuItem key={time.value} value={time.value}>
              {time.label}
            </MenuItem>)}
          </TextField>
        </FormControl>}
      </Grid>
      {tlm.TankShape !== "pulseHUB" && <Grid container
        direction="row"
        justify="flex-start"
        alignItems="center"
        item>
        <Grid item xs>
          <FormControl className={classes.formControl}>
            <TextField type="number" label={t("levelMonitorMeasurementOffset")}
              inputRef={rtlmMeasurementOffset}
              value={tlmMeasurementOffset}
              onChange={e => setTlmMeasurementOffset(e.target.value)}
            />
            <span>{dimensionUnit}</span>
          </FormControl>
          <Tooltip title={t("offsetHelp")}>
            <IconButton onClick={handleOffsetHelpOpen}>
              <HelpIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>}
      <Grid item xs>
        <FormControl className={classes.formControl} >
          <TextField
            select
            label={t("tankType")}
            value={tankType}
            onChange={e => setTankType(e.target.value)}
          >
            {tankTypes.map(type => <MenuItem key={type} value={type}>
              {t(type.toLowerCase())}
            </MenuItem>)}
          </TextField>
        </FormControl>
      </Grid>
      <Grid item xs>
        {tlm.TankShape !== "pulseHUB" && <FormControl className={classes.formControl}>
          <p>{t("maximumCapacity")}: {tlm.FillCapacity} {tlm.VolumeUnit === 'gallons' ? t("gal") : t("l")}</p>
        </FormControl>}
      </Grid>
      <Grid item xs>
        <FormControl className={classes.formControl} >
          <FormLabel component="legend">{t("highLevelAlarm_caps")}</FormLabel>
          <RadioGroup row {...isFillLevelAlarm}>
            <FormControlLabel value="true" control={<Radio />} label={t("yes")} />
            <FormControlLabel value="false" control={<Radio />} label={t("no")} />
          </RadioGroup>
        </FormControl>
        {isFillLevelAlarm.value === 'true' && <FormControl className={classes.formControlNumber}>
          <TextField type="number" label={t("highLevelAlarm_caps")} {...fillAlarmValue}
            inputRef={rfillAlarmValue}
            helperText={tlm.TankShape === "pulseHUB" ? "percent" : (tlm.VolumeUnit === 'gallons' ? t("gallons_caps") : t("liters_caps"))} />
        </FormControl>}
      </Grid>
      <Grid item xs>
        <FormControl className={classes.formControl} >
          <FormLabel component="legend">{t("lowLevelAlarm_caps")}</FormLabel>
          <RadioGroup row {...isLowLevelAlarm}>
            <FormControlLabel value="true" control={<Radio />} label={t("yes")} />
            <FormControlLabel value="false" control={<Radio />} label={t("no")} />
          </RadioGroup>
        </FormControl>
        {isLowLevelAlarm.value === 'true' && <FormControl className={classes.formControlNumber}>
          <TextField type="number" label={t("lowLevelAlarmValue")} {...lowLevelAlarmValue}
            inputRef={rlowLevelAlarmValue}
            helperText={tlm.TankShape === "pulseHUB" ? "percent" : (tlm.VolumeUnit === 'gallons' ? t("gallons_caps") : t("liters_caps"))} />
        </FormControl>}
      </Grid>
      <Grid item xs>
        <FormControl className={classes.formControl} >
          <FormLabel component="legend">{tankType === "Regular" ? t("critcallyLowLevelAlarm_caps") : t("criticallyHighLevelAlarm_caps")}</FormLabel>
          <RadioGroup row {...isCriticallyLowLevelAlarm}>
            <FormControlLabel value="true" control={<Radio />} label={t("yes")} />
            <FormControlLabel value="false" control={<Radio />} label={t("no")} />
          </RadioGroup>
        </FormControl>
        {isCriticallyLowLevelAlarm.value === 'true' && <FormControl className={classes.formControlNumber}>
          <TextField type="number" label={tankType === "Regular" ? t("critcallyLowLevelAlarm_caps") : t("criticallyHighLevelAlarm_caps")} {...criticallyLowLevelAlarmValue}
            inputRef={rcriticallyLowLevelAlarmValue}
            //!!CI:  Tank Type should change labels Fill to Low, and Low to High
            helperText={tlm.TankShape === "pulseHUB" ? "percent" : (tlm.VolumeUnit === 'gallons' ? t("gallons_caps") : t("liters_caps"))} />
        </FormControl>}
      </Grid>
      {(selectedDevice.type === "pressure" || selectedDevice.type === "cellular") && <Grid item xs>
        <FormControl className={classes.formControl} >
          <TextField
            select
            label={t("gpsEnableCheckboxText")}
            value={gpsEnableSelect.value}
            onChange={e => handleGpsEnableList(e.target.value)}
          >
            {gpsSettings.map(setting => <MenuItem key={setting.value} value={setting.value}>
              {setting.label}
            </MenuItem>)}
          </TextField>
        </FormControl>
      </Grid>}
      {(selectedDevice.type === "cellular") && <Grid item xs>
        <FormControl className={classes.formControl} >
            <TextField
              select
              label={t("waveguideEnableCheckboxText")}
              value={waveguideEnableSelect.value}
              onChange={e => handleWaveguideEnableList(e.target.value)}
            >
              {waveguideSettings.map(setting => <MenuItem key={setting.value} value={setting.value}>
                {setting.label}
              </MenuItem>)}
            </TextField>
          </FormControl>
        </Grid>}

      <div className={classes.btnActions}>
        <Button className={classes.clickButtons} variant="contained" color="primary" onClick={() => handleClick(false)}>
          {t("save")}
        </Button>
        <Button className={classes.clickButtons} variant="contained" color="primary" onClick={() => handleClick(true)}>
          {t("saveAndExit")}
        </Button>
        <Button className={classes.clickButtons} onClick={() => handleExit()}>
          {t("cancel")}
        </Button>
      </div>

      {offsetHelpOpen && <Dialog className={classes.infoDialog} disableEscapeKeyDown open={offsetHelpOpen} onClose={handleOffsetHelpClose}>
        <DialogTitle>{t("tankLevelMonitorOffset")}</DialogTitle>
        <DialogContent className={classes.root}>
          <Typography paragraph variant="body2">
            {t("theTankLevelMonitorOffsetIsUsed")}
          </Typography>
          <Typography paragraph variant="body2">
            {t("theTankOffsetCanAlsoBeUsed")}
          </Typography>
          <Typography paragraph variant="body2">
            {t("noteOffsetForPressure")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOffsetHelpClose} color="primary">
            {t("close")}
          </Button>
        </DialogActions>
      </Dialog>}
      {gpsDialogueOpen && <Dialog className={classes.infoDialog} disableEscapeKeyDown open={gpsDialogueOpen} onClose={handleGpsDialogueClose}>
        <DialogTitle>{t("gpsEnableCheckboxText")}</DialogTitle>
        <DialogContent className={classes.root}>
          <Typography paragraph variant="body2">
            {t("tankFinderExplanation1")}
          </Typography>
          <Typography paragraph variant="body2">
            {t("tankFinderExplanation2")}
          </Typography>
          <Typography paragraph variant="body2">
            {t("tankFinderExplanation3")}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleGpsDialogueClose} >
            {t("cancel")}
          </Button>
          <Button onClick={handleSetGpsCheck} color="primary" variant="contained">
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>}
      {removeMonitorDialogue && <Dialog className={classes.infoDialog} disableEscapeKeyDown open={removeMonitorDialogue} onClose={handleRemoveMonitorDialogueClose}>
        <DialogTitle>{t("removeMonitor")}</DialogTitle>
        <DialogContent className={classes.root}>
          {t("areYouSure")}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveMonitorDialogueClose} >
            {t("cancel")}
          </Button>
          <Button onClick={handleRemoveMonitor} color="primary" variant="contained">
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>}
    </>
  );
};

export default TLMSettings;
